/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('PrincipalProfile', PrincipalProfile);

    PrincipalProfile.$inject = ['$q', 'JhiTrackerService', 'AccountProfileService'];

    function PrincipalProfile ($q, JhiTrackerService, AccountProfileService) {
        var _identity;

        var service = {
            identity: identity
        };

        return service;

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            AccountProfileService.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                deferred.resolve(_identity);
                //todo tracker
                //JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                deferred.resolve(_identity);
            }
        }
    }
})();
